import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import { getUser, signIn as sendSignInRequest } from '../api/auth';
import { disconnectNotificationSocket } from '../utils/notificationSocket';

function AuthProvider(props) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function () {
      const result = await getUser();
      if (result.isOk) {
        setUser(result.data);
      }

      setLoading(false);
    })();
  }, []);

  const signIn = useCallback(async (username, password) => {
    const result = await sendSignInRequest(username, password);
    if (result.isOk) {
      setUser(result.data);
    }
    return result;
  }, []);

  // Admin header user switch (or any other flow) can update active user
  // without forcing full page reload. Keep this as a simple setter.
  const setActiveUser = useCallback((nextUser) => {
    setUser(nextUser);
  }, []);

  const signOut = useCallback(() => {
    disconnectNotificationSocket();
    // 1. User state temizle
    setUser();
    
    // 2. Uygulamaya ait localStorage temizle
    const appKeys = [
      'jwt_token',
      'KULLANICI',
      'HAKLkp',
      'EKRANLkp',
      'ROLLkp',
      'FIRMALkp',
      'KULLANICILkp',
      'KULLANICISECIMLkp',
      'ULKELkp',
      'ILLkp',
      'ILCELkp',
      'sabitLkp',
      'sabitgrupLkp',
      'islemsablonLkp'
    ];
    
    appKeys.forEach(key => {
      localStorage.removeItem(key);
    });
    
    // 3. SessionStorage temizle (uygulama özelinde)
    appKeys.forEach(key => {
      sessionStorage.removeItem(key);
    });
    
    // 4. Axios headers temizle
    delete window.axios?.defaults?.headers?.common['Authorization'];
    
    // 5. Global state (glb) temizle
    if (window.glb && window.glb.default) {
      // Sadece uygulama verilerini temizle, diğer global değişkenleri koru
      const preservedKeys = ['cid', 'CID', 'kulid', 'KULID'];
      const preserved = {};
      
      preservedKeys.forEach(key => {
        if (window.glb.default[key] !== undefined) {
          preserved[key] = window.glb.default[key];
        }
      });
      
      window.glb.default = preserved;
    }
  }, []);


  return (
    <AuthContext.Provider value={{ user, signIn, signOut, setActiveUser, loading }} {...props} />
  );
}

const AuthContext = createContext({});
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth }
